import React from 'react';
import { Col } from '@freecodecamp/ui';

import Map from '../../Map/index';
import { Spacer } from '../../helpers';
import { type SuperBlocks } from '../../../../../shared/config/curriculum';
import BigCallToAction from './big-call-to-action';

const Certifications = ({
  allChallenges
}: {
  allChallenges: {
    id: string;
    superBlock: SuperBlocks;
  }[];
}): JSX.Element => {
  return (
    <Col
      className='container certification-new-section'
      
    >
      <Spacer size='medium' />
      <Map allChallenges={allChallenges} forLanding={true} />
   
      
    </Col>
  );
};

Certifications.displayName = 'Certifications';
export default Certifications;
